// extracted by mini-css-extract-plugin
export var compactFilters = "_hi-4";
export var detailImage = "_hi-1";
export var dropdownContainer = "_hi-2";
export var imageContainer = "_hi-0";
export var selectedCard = "_hi-3";